export enum CommonStrings {
  All = 'pSrO',
  None = '3JN7',
  UserID = 'IUDx',
  PIN = 'xepQ',
  Quantity = 'nB26',
  Unknown = 't2TN',
  Filters = 'VG67',
  // Add more common strings here
}
